import "./auth-shell.scss";

import { LocalProfile } from "@core/model/local-profile";
import { ApiToFormService } from "@core/services/api-to-form.service";
import { useUserIdentityContext } from "@core/services/user-identity.context";
import { PROFILE } from "@core/utility/settings";
import { useQyGetPerson } from "@factory/query/person.query";
import StorageService from "@shared/services/storage.service";
import { Outlet } from "react-router-dom";

import { appConfig } from "../../../app.config";
import { appFeature } from "../../../app.feature";
import { useAuthShellNavigation } from "./auth-shell-navigation";

export function AuthShell() {
  const { getAuthUser } = useUserIdentityContext();
  const logo = `${
    appConfig.assetPath
  }/icon-192x192.png?${new Date().toISOString()}`;
  const { headerElement, navigationElement } = useAuthShellNavigation(
    logo,
    appFeature.company
  );
  const { userCode } = getAuthUser();

  // PERSON API
  const handlePersonSuccess = (response: any) => {
    const responseData = response.data ?? [];
    if (responseData.length === 0) {
      return;
    }

    const mappedData = ApiToFormService.MapProfile(responseData[0]);
    StorageService.save<LocalProfile>(PROFILE, mappedData);
  };
  useQyGetPerson(
    "",
    1,
    0,
    undefined,
    { code: userCode },
    !!userCode,
    handlePersonSuccess
  );

  return (
    <div id="AuthShell" className="auth-shell">
      {headerElement}

      <section className="flex mt-4">
        {navigationElement}

        <section className="flex-1 bg-gray-50 rounded-lg mr-4 ml-4 md:ml-0 overflow-y-auto">
          <Outlet />
        </section>
      </section>
    </div>
  );
}

export default AuthShell;
